<template>
    <crud-facecade
        ref="sendrecord_list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        :selection="true"
        @selectionChange="checkedRow"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
        <template slot="filter">
            <el-col :md="8" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
        </template>
        <template slot="filter-after">
            <el-button type="primary" size="mini" @click="sendRecord">回传</el-button>
        </template>
        <template slot="patient_info" slot-scope="{ row }">
            <el-row>
                <el-col :span="1" class="height-p100">
                    <div
                        class="surgery-status-tag"
                        :class="
                            row.surgery_info.enum_surgery_status == 30
                                ? 'bg-danger'
                                : row.surgery_info.enum_surgery_status == 20 || row.surgery_info.enum_surgery_status == 10
                                ? 'bg-primary'
                                : 'bg-info'
                        "
                    >
                        &nbsp;<br />&nbsp;<br />&nbsp;
                    </div>
                </el-col>
                <el-col :span="23" class="padding5 padding-none-v">
                    <div class="fg-info">
                        {{ `${row.patient_name}` }} &nbsp;<el-tag :type="row.surgery_info.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="row.surgery_info.enum_surgery_type">
                            {{ row.surgery_info.surgery_type }}</el-tag
                        >
                        <span class="circle fg-red borderd" v-if="row.surgery_info.is_reoperation">再</span>
                    </div>
                    <div class="fg-info">
                        {{ `(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.surgery_info.dic_section || '--'} ${row.surgery_info.bed_no || '--'}ssss)` }}
                        <span class="circle fg-red borderd" v-if="row.surgery_info.is_reoperation">再</span>
                    </div>
                    <div class="ellipsis">
                        <b>{{ row.surgeries }}</b>
                    </div>
                </el-col>
            </el-row>
        </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryinfoSendrecord`,
    props: {

    },
    data() {
        return {
            title: `手术日志`,
            messageList: [],
            checkedRows: [],
            url: { baseURL: `/api/AcisSystem/SurgeryInfoSendRecord/`,
                get: () => {
                    return this.ReloadListData()
                } },
            buttons: [],
            rdate: [this.$moment().add(-2, `days`).format(`YYYY/MM/DD`), this.$moment().add(1, `days`).format(`YYYY/MM/DD HH:mm:ss`)],
            users: []
        }
    },
    created() {

        // this.loadUsers()
    },
    computed: {
        ...mapGetters([`sys_enums`]),
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `custom`,
                prop: `patient_info`,
                label: `患者信息`,
                width: `260`,
                isListable: true
            },
            {
                type: `select`,
                prop: `send_type`,
                label: `回传类型`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true,
                options: this.sys_enums.SurgeryInfoSendType || []
            }, {
                type: `select`,
                prop: `send_status`,
                label: `回传状态`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true,
                options: this.sys_enums.SurgeryInfoSendStatus || []
            },
            {
                type: `string`,
                prop: `modifier`,
                label: `操作人`,
                isListable: true,
                width: `120`,
                isExpand: false,
                config: {
                    collapseTags: false
                }
            }, {
                type: `datetime`,
                prop: `modify_date`,
                label: `回传时间`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }, {
                type: `string`,
                prop: `send_msg`,
                label: `请求内容`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }, {
                type: `string`,
                prop: `return_msg`,
                label: `返回内容`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }, {
                type: `string`,
                prop: `remark`,
                label: `备注`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        ReloadListData() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SurgeryInfoSendRecord/GetSurgeryInfoSendRecord`, { begin: this.rdate[0], end: this.rdate[1] })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        checkdata() {
            return new Promise((resolve, reject) => {
                let that = this
                if (that.checkedRows.length > 0) {
                    that.checkedRows.forEach(d => {
                        if (d.send_status === 2) {
                            that.$message.warning(`请选择失败的记录回传！`)
                            resolve(false)
                        }
                    })
                } else {
                    that.$message.warning(`请选择失败的记录回传！`)
                    resolve(false)
                }
                resolve(true)
            })
        },
        sendRecord() {
            let that = this
            that.checkdata().then(val => {
                if (val) {
                    let reqs = that.checkedRows.map(d => {
                        let postdata = {
                            surgeryId: d.biz_surgeryInfo_id,
                            surgeryInfoSendType: d.send_type
                        }
                        return that.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, postdata)
                    })
                    that.myaxios.all(...reqs).then(() => {
                        that.$message.success(`回调成功`)
                        that.$refs.sendrecord_list.ReloadListData()
                    })
                }
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`sendrecord_list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/SendRecord/Index.vue